import { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
  const [theme, setTheme] = useState<"dark" | "light">(() => {
    const saved = localStorage.getItem("mavelux-theme");
    if (saved === "light" || saved === "dark") return saved;
    return "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    const meta = document.getElementById("theme-meta") as HTMLMetaElement | null;
    if (theme === "dark") {
      root.classList.add("dark");
      if (meta) meta.content = "#0a1628";
    } else {
      root.classList.remove("dark");
      if (meta) meta.content = "#f8f9fc";
    }
    localStorage.setItem("mavelux-theme", theme);
  }, [theme]);

  return (
    <button
      onClick={() => setTheme((t) => (t === "dark" ? "light" : "dark"))}
      className="p-2.5 rounded-xl bg-gray-100 dark:bg-navy-800 text-gray-600 dark:text-metallic-silver hover:bg-gray-200 dark:hover:bg-navy-700 transition-colors"
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    >
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
